<template>
  <div class="d-inline text-lg-right">
    <ButtonForFiltersWithManyValues
      v-if="filterIsTypeOfArray"
      v-for="(value) in arrayFilterValues"
      :key="value" :value="value"
      :filterPath="filter.path"
      :filterName="filter.name"
    />
    <button
      v-if="!filterIsTypeOfArray"
      @click="removeFilter()"
      type="button"
      class="filter mt-0"
    >
      {{ valueBasedOnFilterType }}
      <span class="filter__close icon-close-big"></span>
    </button>
  </div>
</template>

<script>
  /* global I18n */
  import { mapActions } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import FormatDate from '@/shared/mixins/format_date';
  import ButtonForFiltersWithManyValues from './button_for_filters_with_many_values';
  import { ARTWORKS_FILTERS } from '../../../../consts';

  export default {
    name: 'ActiveFilterButton',
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    mixins: [FormatDate],
    components: {
      ButtonForFiltersWithManyValues,
    },
    props: {
      filter: {
        type: Object,
        required: true,
      },
    },
    computed: {
      filterIsTypeOfArray() {
        return Array.isArray(this.filter.value);
      },
      arrayFilterValues() {
        return this.filter.value;
      },
      valueBasedOnFilterType() {
        const translation = I18n.t(`search_page.artworks_tab.active_filters_names.${this.filter.name}`);
        let value = this.filter.value;

        if (this.filterIsTypeOfDate) {
          value = `${translation}: ${this.formatDate(this.filter.value)}`;
        }

        if (this.filterIsTypeOfPrice) {
          const formattedPrice = I18n.t('price_with_currency', {
            price: this.formatPrice(this.filter.value),
          });

          value = `${translation}: ${formattedPrice}`;
        }

        return value;
      },
      filterIsTypeOfDate() {
        return this.filter.name === ARTWORKS_FILTERS.DATES.FROM.NAME ||
          this.filter.name === ARTWORKS_FILTERS.DATES.TO.NAME;
      },
      filterIsTypeOfPrice() {
        return this.filter.name === ARTWORKS_FILTERS.PRICES.FROM.NAME ||
          this.filter.name === ARTWORKS_FILTERS.PRICES.TO.NAME;
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      removeFilter() {
        this.getArtworksWhenFilterIsChanging(
          { path: this.filter.path, value: this.emptyValue() },
        );
      },
      emptyValue() {
        if (Array.isArray(this.filter.value)) {
          return [];
        }
        return null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/active_filters_buttons/button.vue?4e6f7417